const routes = {
  path: "/descargas",
  name: "ZonaDescargas",
  component: () => import("./views/ZonaDescargas.vue"),
  meta: { requiresAuth: true },
  props: (route) => Object.assign({}, route.query, route.params),
};

export default routes;
